<template>
    <section class="sessao-landing-page" id="agendar">
        <!-- <h2 class="titulo-padrao">CTA</h2> -->
        
        <section class="conteudo-sessao-landing-page">
            <h2 class="titulo-final-principal" data-aos="fade" data-aos-duration="1200">Pronto para renovar?</h2>
            <p class="subtitulo-final-principal" data-aos="fade" data-aos-delay="200" data-aos-duration="1200">Higienização profissional, qualidade e cuidado para deixar seus estofados como você gosta.</p>
            
            <a data-aos="fade" data-aos-delay="250" data-aos-duration="1200" href="https://wa.me/5535999013609?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20fazer%20um%20or%C3%A7amento" target="_blank" class="button">
                Agende agora
                <div class="seta-botao">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-narrow-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l14 0" /><path d="M15 16l4 -4" /><path d="M15 8l4 4" /></svg>
                </div>
            </a>
        </section>
    </section>
</template>

<script>
export default{
    name: 'CTAFinalLandingPage'
}
</script>

<style scoped>
.sessao-landing-page{
    height: auto;
    width: 100%;
    padding: 62px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    /* background-color: rgb(241, 241, 241); */
    border-radius: 10px;
}

.conteudo-sessao-landing-page{
    height: auto;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
}

.titulo-padrao{
    font-size: 32px;
}

.titulo-final-principal{
    font-size: 52px;
}

.subtitulo-final-principal{
    font-size: 20px;
}

.button {
    padding: 14px 28px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    background-color: var(--cor-tema);
    color: var(--cor-branco-texto);
    filter: drop-shadow(0 0 12px #0f0f5410);
    text-decoration: none;
}

.seta-botao{
    width: 15px;
    height: 15px;
}

@media (min-width: 768px) and (max-width: 1200px){
    .sessao-landing-page{
        padding: 42px 24px;
    }

    .subtitulo-final-principal, .titulo-final-principal{
        text-align: center;
    }
}

@media (max-width: 600px) {
    .sessao-landing-page{
        padding: 42px 24px;
    }

    .titulo-final-principal{
        font-size: 46px;
        text-align: center;
    }

    .subtitulo-final-principal{
        font-size: 16px;
        text-align: center;
    }

    .button{
        font-size: 15px;
    }
}
</style>